<template>
  <div class="campus">
    <SectionHeader
      title="Campus Experiences"
      imgSrc="campus-experiences/campus-ex-titlebg.jpeg"
    />
    <div class="carousel_container">
      <Carousel :childId="4" />
    </div>
  </div>
</template>

<script>
import SectionHeader from "@/components/SectionHeader.vue";
import Carousel from "@/components/Carousel";

export default {
  name: "CampusExperiences",
  components: {
    SectionHeader,
    Carousel,
  },
};
</script>

<style lang="scss" scoped>
.carousel_container {
  margin-block: 50px;
}

.row_header {
  font-family: Formula1-Display-Bold;
  font-size: 33px;
  color: #00939b;
  text-align: center;
  line-height: 75px;
  font-weight: 500;
  padding-top: 3em;
  padding-bottom: 1em;
}
</style>
